import { Typography, Paper, Hidden } from '@material-ui/core'

import { getTranslate } from '../../localization'
import RenderPage from './RenderPage'
import SettingMenu from './SettingMenu'
import SettingMenuMobile from './SettingMenuMobile'
import { useStyles } from './styles/index.styles'

const Settings = () => {
  const classes = useStyles()

  return (
    <>
      <div className={classes.header}>
        <Typography variant="h2">{getTranslate('Settings')}</Typography>
      </div>
      <Hidden smDown>
        <Paper className={classes.flexDisplay} elevation={10}>
          <div className={classes.titleAndList}>
            <SettingMenu />
          </div>
          <div className={classes.pageContainer}>
            <RenderPage />
          </div>
        </Paper>
      </Hidden>
      <Hidden mdUp>
        <SettingMenuMobile />
      </Hidden>
    </>
  )
}
export default Settings
